import React from 'react';
import PropTypes from 'prop-types';
import { Navbar } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { Meteor } from 'meteor/meteor';

import AuthenticatedNavigation from '../AuthenticatedNavigation';
import PublicNavigation from '../PublicNavigation';
import LinkContainer from '../../containers/LinkContainer';
import { isGeoMotionVideo } from '../../../modules/checkDeployEnv';

const { shortProductName } = Meteor.settings.public;

const Navigation = props => {
  const { authenticated, deployEnv, isFullScreen } = props;
  if (!isFullScreen) {
    return (
      <Navbar collapseOnSelect bg="light" expand="lg">
        <LinkContainer to="/">
          <Navbar.Brand>
            <img
              className="d-inline-block align-top"
              src="/ias-logo/logo.png"
              height="20"
              width="20"
              alt="logo"
            />
            <p className="d-inline">{` ${shortProductName}`}</p>
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse
          id="basic-navbar-nav"
          className={!authenticated && !isGeoMotionVideo(deployEnv) && 'justify-content-end'}
        >
          {authenticated ? <AuthenticatedNavigation {...props} /> : <PublicNavigation {...props} />}
        </Navbar.Collapse>
      </Navbar>
    );
  }
  return '';
};

Navigation.defaultProps = {
  name: '',
  isAdmin: false,
  isFullScreen: false
};

Navigation.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool,
  name: PropTypes.string,
  deployEnv: PropTypes.string.isRequired,
  isFullScreen: PropTypes.bool
};

export default withRouter(Navigation);
